import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import {
  BreadcrumbModule,
  ModalModule,
  TableModule,
  EmptyStateModule,
  StatusModule,
  TimepickerModule,
  DropdownModule
} from '@michelin/theme';
import { SharedModule } from '../../shared/shared.module';
import { CustomerSelectModelComponent } from '../../shared/components/customer-select-model/customer-select-model.component';
import { LogsComponent } from './components/logs/logs.component';

@NgModule({
  declarations: [LogsComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    BreadcrumbModule,
    ModalModule,
    TableModule,
    EmptyStateModule,
    SharedModule,
    CustomerSelectModelComponent,
    StatusModule,
    TimepickerModule,
    DropdownModule
  ],
  exports: [LogsComponent]
})
export class LogsModule {}
